import { useSelector } from "react-redux";
import useAirUserRoles from "utils/AuthUtils";

/**
 * Whether DEV-only UI should currently render: the user IS a developer AND
 * they haven't toggled admin features off via the header icon (EsgAdminViewToggle).
 * Shares the same toggle/slice as useEsgAdminFeaturesVisible, so one switch controls
 * both ESG_ADMIN-only and DEV-only UI.
 */
export default function useDevFeaturesVisible() {
  const { isDeveloper } = useAirUserRoles();
  const showAdminFeatures = useSelector((state) => state.adminView?.showAdminFeatures ?? true);
  return isDeveloper() && showAdminFeatures;
}
